<template>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button color="primary" expand="block" fill="outline" size="small" v-on:click="scanCode">
          <ion-icon slot="start" color="primary" ios="ios-camera" md="md-camera" />Scan QRCode
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button color="danger" expand="block" fill="outline" size="small" v-on:click="clearCode">
          <ion-icon slot="start" color="danger" ios="ios-trash" md="md-trash" />Clear QRCode
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</template>

<script>
import Plugins from "../mixins/Plugins";
import Helpers from "../mixins/Helpers";
import Field from "../models/Field";
import Value from "../models/Value";
import ScanQrcode from "../views/ScanQrcode.vue";
export default {
  name: "field-qrcode",
  mixins: [Plugins, Helpers],
  props: ["field", "value"],
  mounted() {},
  methods: {
    clearCode() {
      this.value.value = "";
    },
    async scanCode() {
      if (await this.platformMobile()) {
        try {
          this.value.value = await this.scanQrcode(false, true, true);
        }
        catch (error) {
          this.showWarning(error);
        }
      }
      else {
        let modal = await this.showModal(ScanQrcode);
        let dismissed = await modal.onDidDismiss();
        if (dismissed && dismissed.data && dismissed.data.code) {
          this.value.value = dismissed.data.code; 
        }
      }
    }
  }
};
</script>

<style scoped>
</style>